<template>
  <div class="container">
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker @confirm='changetime' v-model="currentDate" type="month-day" title="选择预约时间"
        :min-date="minDate" :max-date="maxDate" />
    </van-popup>
    <van-dialog @confirm='checked=true' @cancel='checked=false' v-model="ProtocolShow" title="预约协议" show-cancel-button
      confirmButtonColor='#4B62EC'>
      <div style="padding:20px">

        <span>1、甲方依法收取场地使用费，向乙方提供预约记录凭证。</span>
        <br>
        <span>2、预约停车后，请乙方按时入场。</span>
      </div>
    </van-dialog>

    <div class="bind__header">
      <div class="bind__header__info">
        <span class="bind__header__info__title">预约停车</span>
        <span class="bind__header__info__content">点击查看预约记录</span>
        <van-button type="primary" color="#4897FA" to="reserve-parking" size="small" style="padding: 5px;"
          @click="GoJump()">预约记录
        </van-button>
      </div>
      <div class="bind__header__2dpic" :style="{
          backgroundImage:
            'url(' + require('@/assets/payment-related/BD_carbanner.png') + ')'
        }"></div>
    </div>
    <div class="bind-modal">
      <div class="title">
        请输入相关信息预约停车
      </div>
      <div class="page page-index">
        <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
      </div>
      <van-cell-group>
        <van-cell title="车场名称" value="凤台南路停车场" />
        <van-cell title="车场车位" :value="$route.query.data.parkingNumber" />
        <van-cell @click="show=true" title="停车时间" :value="FromData.time.substring(0,10)" />
        <!-- <van-cell title="预约押金" value="5￥" /> -->
        <van-cell title="">
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #right-icon>
            <van-checkbox shape="square" v-model="checked">预约协议</van-checkbox>
          </template>
        </van-cell>
      </van-cell-group>

      <div class="btn_box">
        <van-button @click="createPlateNumber" size="large" class="blue-btn">下单预约</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import keyboard from '@/components/keyboard/index'
import { Dialog, DatetimePicker, popup, checkbox } from 'vant'
import { appointmentParking } from '@/api/park'
import {
  getLocalStorage
} from "@/utils/auth";
import { parseTime, getTimeval } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'BindCar',
  components: {
    keyboard,
    [Dialog.Component.name]: Dialog.Component,
    [DatetimePicker.name]: DatetimePicker,
    [checkbox.name]: checkbox,
    [popup.name]: popup,
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token', 'backflow', 'CJ_Phone'])
  },
  data () {
    return {
      ProtocolShow: true,
      checked: false,
      show: false,
      minDate: new Date(new Date().getFullYear(), (new Date().getMonth()), new Date().getDate()),
      maxDate: new Date(new Date().getFullYear() + 1, 1, 1),
      currentDate: new Date(),
      getInfo_Loading: null,
      plateNumber: [],
      FromData: {
        time: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        name: '',
        plateNumber: [],
        carNumber: '',
        park: ''
      },
    }
  },
  mounted () {
    console.log(this.CJ_Phone)
  },
  methods: {
    GoJump () {
      this.$router.push({
        name: 'Reserve-Parking',
      })
    },
    changetime (val) {
      console.log(parseTime(new Date(val)))
      let time = parseTime(new Date(val))
      this.FromData.time = time
      this.show = false
    },
    // 新增车牌
    createPlateNumber () {
      let _this = this
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      if (!_this.checked) {
        _this.ProtocolShow = true
        _this.getInfo_Loading.clear()
        return
      }
      let params = {
        // notifyUrl: `${config.returnURL}/notifyUrlV3/apiUnionPay`,
        // returnUrl: `${config.returnURL}/PayResult`,
        // payTypeOther: 1, //城建银联1 默认银联0
        // outTradeNo: `wx${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${_this.orders.id}_2`, //商户系统内部订单号，要求32个字符内，只能是数字、大小写字母_-|* 且在同一个商户号下唯一
        parkId: _this.$route.query.data.parkid, //停车场Id,
        parkingNumber: _this.$route.query.data.other,//车位号码
        parkName: _this.$route.query.data.parkName, //停车场名称
        orderType: 3,  //1、停车场临停订单 2、路边临停订单 3、预约订单 4、共享订单 5、包月订单 6、
        orderStatus: 1,
        billingStatus: 0, //开票状态
        orderPayTime: parseTime(new Date()),//订单付款时间
        startTime: parseTime(new Date((this.FromData.time).replace(/-/g, '/'))),
        endTime: parseTime(new Date(new Date((this.FromData.time).replace(/-/g, '/')).getTime() + 24 * 60 * 60 * 1000)),
        zfbUserid: '',
        wxOpenid: _this.phone ? _this.phone : getLocalStorage("cj_phone"),
        otherId: '',
        other: _this.$route.query.data.parkingNumber,
        // chargeMoney: (_this.orders.chargeMoney).toString(), //应收金额
        // paidMoney: _this.payMoney * 100,
        // discountMoney: (_this.orders.discount).toString(), //折扣金额
        cardNumber: _this.plateNumber.join(''), //车牌号
        // payType: _this.fristPayWay.payChannel,
        isParkingOrRoadside: 1,//区别路内外
        isJfOrQfbj: 'JF',
        list: null,
        // mac: _this.orders.mac, //车牌号,
        // isFieldOrDoorway: _this.orders.mac ? '门口缴费' : "场内缴费",
        kernel: '1',//0支付宝 1微信
      }
      appointmentParking(params).then(res => {
        _this.getInfo_Loading.clear()
        console.log(res)
        if (res.status == 1001) {
          _this.$toast.success(res.body)
          setTimeout(() => {
            this.$router.push({
              name: 'Reserve-Parking',
            })
          }, 3000);

        } else {
          _this.$toast.fail('预约失败，请联系管理员')
        }
      }).catch(err => {
        _this.getInfo_Loading.clear()
        _this.$toast.fail('预约失败，请联系管理员')
      })
    },
    change (val) {
      this.plateNumber = val
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #f5f5f5;
  position: relative;

  .bind__header {
    display: flex;
    flex-direction: colunm;
    flex-wrap: wrap;
    padding: 25px;
    background: linear-gradient(
      -52deg,
      rgba(26, 73, 251, 1),
      rgba(71, 140, 245, 1)
    );

    &__info {
      width: 50%;
      color: rgba(255, 255, 255, 1);

      span {
        display: block;
      }

      &__title {
        font-size: 17px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        line-height: 26px;
      }

      &__content {
        font-size: 14px;
        line-height: 38px;
      }
    }

    &__2dpic {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 50%;
      height: 20vh;
      min-height: 140px;
    }
  }

  .bind-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    max-width: 90%;
    height: 65vh;
    min-height: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(37, 44, 63, 0.1);
    border-radius: 5px;
    margin: 25vh auto 0;

    .title {
      text-align: center;
      font-size: 17px;
      line-height: 1.5;
      line-height: 1.5;
      padding: 25px 0 10px;
    }

    .btn_box {
      padding: 0 15px;
    }

    .page {
      padding: 10px;
    }
  }
}
</style>